import dayjs from 'dayjs';

export const formatDate = (isoDate: Date | string) => {
  return isoDate ? dayjs(isoDate).format('DD.MM.YYYY') : '-';
};

export const formatDateDashed = (isoDate: Date | string) => {
  return isoDate ? dayjs(isoDate).format('YYYY-MM-DD') : '-';
};

export const formatDateTime = (isoDate: Date | string) => {
  return isoDate ? dayjs(isoDate).format('DD.MM.YYYY HH:mm:ss') : '-';
};
